import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './EntityPageQuery.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HeaderContentEntityPageCompanyHeaderContentFragment = (
  { __typename: 'EntityPageCompanyHeaderContent' }
  & { followers?: Types.Maybe<(
    { __typename?: 'FollowersConnection' }
    & Pick<Types.FollowersConnection, 'total'>
  )>, company?: Types.Maybe<(
    { __typename?: 'Company' }
    & Pick<Types.Company, 'employeesCount'>
    & { companySizeRange?: Types.Maybe<(
      { __typename?: 'CompanySizeRange' }
      & Pick<Types.CompanySizeRange, 'min' | 'max'>
    )>, kununuData?: Types.Maybe<(
      { __typename?: 'CompanyKununuData' }
      & Pick<Types.CompanyKununuData, 'ratingCount' | 'ratingAverage' | 'companyProfileUrl' | 'employerRatingsCount'>
    )> }
  )> }
);

export type HeaderContentEntityPageFallbackHeaderContentFragment = { __typename: 'EntityPageFallbackHeaderContent' };

export type HeaderContentEntityPageGroupPageHeaderContentFragment = { __typename: 'EntityPageGroupPageHeaderContent' };

export type HeaderContentEntityPagePublisherHeaderContentFragment = (
  { __typename: 'EntityPagePublisherHeaderContent' }
  & { followers?: Types.Maybe<(
    { __typename?: 'FollowersConnection' }
    & Pick<Types.FollowersConnection, 'total'>
  )> }
);

export type HeaderContentEntityPageTopicPageHeaderContentFragment = (
  { __typename: 'EntityPageTopicPageHeaderContent' }
  & { followers?: Types.Maybe<(
    { __typename?: 'FollowersConnection' }
    & Pick<Types.FollowersConnection, 'total'>
  )> }
);

export type HeaderContentFragment = HeaderContentEntityPageCompanyHeaderContentFragment | HeaderContentEntityPageFallbackHeaderContentFragment | HeaderContentEntityPageGroupPageHeaderContentFragment | HeaderContentEntityPagePublisherHeaderContentFragment | HeaderContentEntityPageTopicPageHeaderContentFragment;

export type SocialProofFragment = (
  { __typename?: 'EntityPageSocialProofConnection' }
  & Pick<Types.EntityPageSocialProofConnection, 'proofType' | 'total'>
  & { edges: Array<Types.Maybe<(
    { __typename?: 'EntityPageSocialProofEdge' }
    & { node?: Types.Maybe<(
      { __typename?: 'EntityPageSocialProof' }
      & { xingId?: Types.Maybe<(
        { __typename?: 'XingId' }
        & Pick<Types.XingId, 'id' | 'pageName' | 'displayName' | 'gender'>
        & { profileImage?: Types.Maybe<Array<Types.Maybe<(
          { __typename?: 'ProfileImage' }
          & Pick<Types.ProfileImage, 'url'>
        )>>>, clickReasonProfileUrl?: Types.Maybe<(
          { __typename?: 'ClickReason' }
          & Pick<Types.ClickReason, 'profileUrl'>
        )> }
      )> }
    )> }
  )>> }
);

export type EntityPageQueryVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
  socialProofClickReasonsKey: Types.ClickReasonsEnum;
}>;


export type EntityPageQuery = (
  { __typename?: 'Query' }
  & { entityPageEX?: Types.Maybe<(
    { __typename?: 'EntityPage' }
    & Pick<Types.EntityPage, 'id' | 'globalId' | 'title' | 'slug' | 'slogan' | 'focusType' | 'publicationStatus' | 'visibility'>
    & { contract: (
      { __typename?: 'EntityPageContract' }
      & Pick<Types.EntityPageContract, 'type'>
    ), context?: Types.Maybe<(
      { __typename?: 'EntityPageContext' }
      & Pick<Types.EntityPageContext, 'companyId' | 'cppId'>
    )>, properties: (
      { __typename?: 'EntityPageProperties' }
      & Pick<Types.EntityPageProperties, 'parentPage' | 'condensedHeader'>
    ), logoImage?: Types.Maybe<Array<(
      { __typename?: 'ScaledImage' }
      & Pick<Types.ScaledImage, 'reference' | 'url'>
    )>>, userPageContext?: Types.Maybe<(
      { __typename?: 'EntityPageUserContext' }
      & { userInteractions?: Types.Maybe<{ __typename: 'EntityPageUserInteractionFallback' } | (
        { __typename: 'EntityPageUserInteractionFollow' }
        & { followState?: Types.Maybe<(
          { __typename?: 'FollowContext' }
          & Pick<Types.FollowContext, 'isFollowing'>
        )> }
      ) | { __typename: 'EntityPageUserInteractionJoin' }>, permissions: (
        { __typename?: 'EntityPagePermissions' }
        & Pick<Types.EntityPagePermissions, 'canEdit' | 'canAdmin'>
      ), socialProof?: Types.Maybe<(
        { __typename?: 'EntityPageSocialProofConnection' }
        & SocialProofFragment
      )> }
    )>, links: (
      { __typename?: 'EntityPageLinks' }
      & Pick<Types.EntityPageLinks, 'self'>
    ), modules?: Types.Maybe<(
      { __typename?: 'EntityPageModules' }
      & { collection: Array<Types.Maybe<(
        { __typename: 'EntityPageAboutUsModule' }
        & Pick<Types.EntityPageAboutUsModule, 'type'>
      ) | (
        { __typename: 'EntityPageGenericModule' }
        & Pick<Types.EntityPageGenericModule, 'globalId' | 'properties' | 'type'>
      ) | (
        { __typename: 'EntityPageHeaderModule' }
        & Pick<Types.EntityPageHeaderModule, 'properties' | 'globalId' | 'type'>
        & { content?: Types.Maybe<(
          { __typename?: 'EntityPageCompanyHeaderContent' }
          & HeaderContentEntityPageCompanyHeaderContentFragment
        ) | (
          { __typename?: 'EntityPageFallbackHeaderContent' }
          & HeaderContentEntityPageFallbackHeaderContentFragment
        ) | (
          { __typename?: 'EntityPageGroupPageHeaderContent' }
          & HeaderContentEntityPageGroupPageHeaderContentFragment
        ) | (
          { __typename?: 'EntityPagePublisherHeaderContent' }
          & HeaderContentEntityPagePublisherHeaderContentFragment
        ) | (
          { __typename?: 'EntityPageTopicPageHeaderContent' }
          & HeaderContentEntityPageTopicPageHeaderContentFragment
        )> }
      )>> }
    )> }
  ) | (
    { __typename?: 'EntityPageError' }
    & Pick<Types.EntityPageError, 'errorType' | 'errorCode'>
  ) | (
    { __typename?: 'EntityPageMoved' }
    & Pick<Types.EntityPageMoved, 'slug'>
  )> }
);



/**
 * __useEntityPageQuery__
 *
 * To run a query within a React component, call `useEntityPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      socialProofClickReasonsKey: // value for 'socialProofClickReasonsKey'
 *   },
 * });
 */
export function useEntityPageQuery(baseOptions: Apollo.QueryHookOptions<EntityPageQuery, EntityPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityPageQuery, EntityPageQueryVariables>(Operations.EntityPage, options);
      }
export function useEntityPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityPageQuery, EntityPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityPageQuery, EntityPageQueryVariables>(Operations.EntityPage, options);
        }
export type EntityPageQueryHookResult = ReturnType<typeof useEntityPageQuery>;
export type EntityPageLazyQueryHookResult = ReturnType<typeof useEntityPageLazyQuery>;
export type EntityPageQueryResult = Apollo.QueryResult<EntityPageQuery, EntityPageQueryVariables>;